enum LoginTypeEnum {
    PARTNER = "partner",
    APPLICATION = "application",
}

export default LoginTypeEnum;
